/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import MotiliButton from 'common/components-v2/buttons/MotiliButton';
import MotiliButtonContainer from 'common/components-v2/buttons/MotiliButtonContainer';
import { FormRow, FormElement } from 'common/components/form/FormLayout';
import Drawer from 'common/components-v2/modal/Drawer';
import { MultiCheckboxAutocomplete } from 'common/components/form/MultiCheckboxAutocomplete';

const AdminWorkOrderRequirementsChecklistAddModal = ({
    checklistOptions,
    handleAddChecklistOnClick: handleAddChecklistOnClickProp,
    handleCloseOnClick,
    isOpen,
}) => {
    const [checklists, setChecklists] = useState([]);
    const [busy, setBusy] = useState(false);

    const handleAddChecklistOnClick = () => {
        setBusy(true);
        try {
            handleAddChecklistOnClickProp(checklists);
        } catch (err) {
            setBusy(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            setBusy(false);
            setChecklists([]);
        }
    }, [isOpen]);

    return (
        <Drawer
            drawerStyle={{
                width: '740px',
                paddingBottom: '75px',
            }}
            onClose={handleCloseOnClick}
            title='Add Checklist'
            open={isOpen}
            closeByDocument={!busy}
            showClose={!busy}
        >
            <FormRow>
                <FormElement>
                    <MultiCheckboxAutocomplete
                        label='SELECT CHECKLIST(S)'
                        placeholder='Select...'
                        options={checklistOptions}
                        value={checklists}
                        onChange={setChecklists}
                    />
                </FormElement>
            </FormRow>
            <FormRow style={{ justifyContent: 'flex-end' }}>
                <MotiliButtonContainer>
                    <MotiliButton
                        text='Cancel'
                        onClick={handleCloseOnClick}
                        disabled={busy}
                        moStyle='normal'
                    />
                    <MotiliButton
                        text='Add'
                        onClick={handleAddChecklistOnClick}
                        busy={busy}
                        disabled={busy || !checklists.length}
                    />
                </MotiliButtonContainer>
            </FormRow>
        </Drawer>
    );
};

AdminWorkOrderRequirementsChecklistAddModal.propTypes = {
    checklistOptions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            requirement: PropTypes.shape({
                name: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
                sections: PropTypes.arrayOf(
                    PropTypes.shape({
                        name: PropTypes.string,
                        sequencePosition: PropTypes.number,
                        items: PropTypes.arrayOf(
                            PropTypes.shape({
                                description: PropTypes.string,
                                sequencePosition: PropTypes.number,
                            })
                        ),
                    })
                ),
            }),
        })
    ).isRequired,
    handleAddChecklistOnClick: PropTypes.func.isRequired,
    handleCloseOnClick: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
};

export default AdminWorkOrderRequirementsChecklistAddModal;
